import s from 'sin';


const sinner = s`button
  p 10 15
  fs 15
  bc hotpink
  br 4
  border 1 solid
  color white
`

const Item = s(({ product }) => s`li`(product.title));
const Grid = s(({ items }) =>
  s`ul`(
    items.map(i =>
      Item({
        key: i.id,    // <- Unique key
        product: i
      })
    )
  )
);

const judgement = s(
  {
    loading: sinner('Seeking Atonement...'),
    error: e => sinner(`There was an error: ${e}`)
  },
  async () => {
    await s.sleep(3000)
    return async () => sinner('Sins Forgiven!')
  }
)

const example = s(() => {
  let count = 0

  return () => sinner({
    onclick: () => count++
  },
    count === 0
    ? 'You are sinless!'
    : `You've committed ${count} sin${count > 1 ? "s" : ""}!`
  )
})

const Button = s(({ name, ...attrs  }) => s`button`(attrs, name));

const List = s(() => {
    let limit = false;
    let count = limit ? 5 : 10;
    let items = Array.from({length: count});

    return s`div`([
        sinner({
            onclick: () => {
                limit = !limit;
            }
        }, limit  ? 'Expand' : 'Collapse'),
        s`ul`(
            items.map((_, idx) => s`li`({key: idx}, idx))
        )
    ])
})

const Collection = s(({ items = [] }, children, { doc, state }) => {
    let filters = {};
    let count = 0;

    const handleClick = (event) => {
        const { name, value } = event.target.dataset;
        console.log('handleClick', event, name, value, filters);
        filters[name] = value;
        count++;
    }

    const products = count % 2 ===  0 ? items : [];

    return () => s`div`([
            Button({
                name: `Colors ${count}`,
                onclick: handleClick,
                'data-name': 'colors',
                'data-value': 'red'
            }),
            Grid({ items: products })
        ])
})

s.mount(
    document.querySelector('#collection'),
    ({}, [], { doc, state }) => {
        const items = JSON.parse(
            document.querySelector('script[data-products]').textContent
        )

        return [judgement(), example(), List(), Collection({
            items,
        })];
    }
)